import { __assign } from "tslib";
import * as React from 'react';
function IconRemoveSizeM(props) {
    return (React.createElement("svg", __assign({}, props, { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }),
        React.createElement("path", { d: "M20 12.4H4V11H20V12.4Z" })));
}
export default IconRemoveSizeM;
